import React from "react";

const Terms = () => (
  <div className="bg-black text-spike-text" data-testid="terms-page">
    <div className="max-w-3xl mx-auto px-6 py-16 lg:py-24">
      <h1 className="font-orbitron text-4xl sm:text-5xl font-black uppercase tracking-tight text-spike-text">
        Terms <span className="text-spike-blue-light">&amp;</span> Conditions
      </h1>
      <p className="mt-3 text-sm text-spike-dim font-exo">Last updated: {new Date().toISOString().slice(0, 10)}</p>

      <div className="prose prose-invert max-w-none mt-10 space-y-6 text-sm leading-relaxed text-spike-text/85 font-exo">
        <section>
          <h2 className="font-orbitron uppercase tracking-wider text-spike-blue-light text-lg">1. Acceptance of Terms</h2>
          <p>
            By accessing or using the Spike Sports website, booking platform or visiting our indoor facility in
            Mississauga, ON (the &ldquo;Service&rdquo;), you agree to these Terms &amp; Conditions. If you do not agree, you may not
            use the Service.
          </p>
        </section>

        <section>
          <h2 className="font-orbitron uppercase tracking-wider text-spike-blue-light text-lg">2. Bookings &amp; Payments</h2>
          <p>
            All net, lane, box and machine bookings are subject to availability and our confirmation. Cancellations
            made less than 24 hours before the booking are non-refundable. Walk-ins are accommodated subject to
            on-site availability and applicable rates posted in-facility.
          </p>
        </section>

        <section>
          <h2 className="font-orbitron uppercase tracking-wider text-spike-blue-light text-lg">3. Liability Waiver</h2>
          <p>
            All participants — including minors with the consent of their parent/guardian — are required to sign the
            Spike Sports Liability Waiver before entering the playing area. Participation involves inherent physical
            risks. By signing the waiver you acknowledge and accept those risks.
          </p>
        </section>

        <section>
          <h2 className="font-orbitron uppercase tracking-wider text-spike-blue-light text-lg">4. Facility Rules</h2>
          <p>
            Approved, non-marking footwear must be worn on all turf lanes. Equipment provided by Spike Sports must be
            handled with care. Any deliberate misuse or damage will be charged at replacement cost.
          </p>
        </section>

        <section>
          <h2 className="font-orbitron uppercase tracking-wider text-spike-blue-light text-lg">5. Memberships</h2>
          <p>
            Membership benefits are personal and non-transferable. Membership credits expire at the end of each
            billing cycle unless otherwise stated. You may cancel a recurring membership at any time from your
            account dashboard; cancellations take effect at the end of the current billing period.
          </p>
        </section>

        <section>
          <h2 className="font-orbitron uppercase tracking-wider text-spike-blue-light text-lg">6. Conduct</h2>
          <p>
            Spike Sports reserves the right to refuse service or remove any visitor whose conduct is unsafe,
            disrespectful or disruptive to other guests, coaches or staff.
          </p>
        </section>

        <section>
          <h2 className="font-orbitron uppercase tracking-wider text-spike-blue-light text-lg">7. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, Spike Sports, its owners, employees, contractors and affiliates
            shall not be liable for any indirect, incidental or consequential damages arising from your use of the
            Service or the facility.
          </p>
        </section>

        <section>
          <h2 className="font-orbitron uppercase tracking-wider text-spike-blue-light text-lg">8. Changes</h2>
          <p>
            We may update these Terms from time to time. Continued use of the Service after changes are posted
            constitutes acceptance of the new Terms.
          </p>
        </section>

        <section>
          <h2 className="font-orbitron uppercase tracking-wider text-spike-blue-light text-lg">9. Contact</h2>
          <p>
            Questions? Email <a href="mailto:info@spikesportscanada.com" className="text-spike-blue-light">info@spikesportscanada.com</a>.
          </p>
        </section>
      </div>
    </div>
  </div>
);

export default Terms;
